<template>
  <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
    <!-- 奖品管理标签页 -->
    <el-tab-pane label="奖品管理" name="first">
      <div class="main">
        <div class="main_r">
          <!-- 搜索栏 -->
          <div class="search">
            <div>
              <el-input v-model="rewardQuery.rewardName" placeholder="请输入奖品名称"></el-input>
              <el-select v-model="rewardQuery.status" placeholder="请选择状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="上架" value="1"></el-option>
                <el-option label="下架" value="0"></el-option>
              </el-select>
              <el-button type="primary" @click="clickRewardQuery">查询</el-button>
              <el-button type="primary" @click="clickRewardQueryReset" plain>重置</el-button>
              <el-button type="primary" @click="clickRewardAdd">新增</el-button>
            </div>
          </div>
          <!-- 搜索栏 End -->

          <!-- 奖品列表 -->
          <el-table :data="rewardList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column prop="rewardImageUrl" label="奖品图片" width="100">
              <template slot-scope="scope">
                <el-image v-if="scope.row.rewardImageUrl" :src="getImageUrl(scope.row.rewardImageUrl)" :preview-src-list="[getImageUrl(scope.row.rewardImageUrl)]" style="width: 50px; height: 50px"></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="rewardName" label="奖品名称"></el-table-column>
            <el-table-column prop="requiredPoints" label="所需积分" width="100"></el-table-column>
            <el-table-column prop="stock" label="实际库存" width="100"></el-table-column>
            <el-table-column prop="totalStock" label="全部库存" width="100"></el-table-column>
            <el-table-column prop="exchangedCount" label="已兑换" width="100"></el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                  {{ scope.row.status === 1 ? '上架' : '下架' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="sortOrder" label="排序" width="80"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="100">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickRewardEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" @click="clickRewardDelete(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleRewardSizeChange"
              @current-change="handleRewardCurrentChange"
              :current-page="rewardPageNo"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="rewardPageSize"
              layout="prev, pager, next, sizes, jumper"
              :total="rewardTotal">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>

        <!-- 新增奖品弹框 -->
        <el-dialog title="新增奖品" :visible.sync="dialogRewardAdd" width="40%" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="rewardAddForm" :model="rewardAddData" label-width="100px">
              <el-form-item label="奖品名称" :required="true">
                <el-input v-model="rewardAddData.rewardName" placeholder="请输入奖品名称" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="所需积分" :required="true">
                <el-input-number v-model="rewardAddData.requiredPoints" :min="1" placeholder="请输入所需积分" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="库存数量" :required="true">
                <el-input-number v-model="rewardAddData.stock" :min="0" placeholder="请输入库存数量" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="状态" :required="true">
                <el-select v-model="rewardAddData.status" placeholder="请选择状态" style="width: 100%">
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序号">
                <el-input-number v-model="rewardAddData.sortOrder" :min="0" placeholder="请输入排序号" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="奖品图片">
                <el-upload
                  class="cover-uploader"
                  :action="''"
                  :http-request="handleRewardAddUpload"
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true">
                  <img v-if="rewardAddData.rewardImageUrl" :src="getImageUrl(rewardAddData.rewardImageUrl)" class="cover-image">
                  <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
              </el-form-item>
              <el-form-item label="奖品描述">
                <el-input type="textarea" :rows="4" v-model="rewardAddData.description" placeholder="请输入奖品描述" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RewardAdd()">确 认</el-button>
            <el-button @click="dialogRewardAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 新增奖品弹框 End -->

        <!-- 编辑奖品弹框 -->
        <el-dialog title="编辑奖品" :visible.sync="dialogRewardEdit" width="40%" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="rewardEditForm" :model="rewardEditData" label-width="100px">
              <el-form-item label="奖品名称" :required="true">
                <el-input v-model="rewardEditData.rewardName" placeholder="请输入奖品名称" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="所需积分" :required="true">
                <el-input-number v-model="rewardEditData.requiredPoints" :min="1" placeholder="请输入所需积分" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="库存数量" :required="true">
                <el-input-number v-model="rewardEditData.stock" :min="0" placeholder="请输入库存数量" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="状态" :required="true">
                <el-select v-model="rewardEditData.status" placeholder="请选择状态" style="width: 100%">
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序号">
                <el-input-number v-model="rewardEditData.sortOrder" :min="0" placeholder="请输入排序号" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="奖品图片">
                <el-upload
                  class="cover-uploader"
                  :action="''"
                  :http-request="handleRewardEditUpload"
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true">
                  <img v-if="rewardEditData.rewardImageUrl" :src="getImageUrl(rewardEditData.rewardImageUrl)" class="cover-image">
                  <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
              </el-form-item>
              <el-form-item label="奖品描述">
                <el-input type="textarea" :rows="4" v-model="rewardEditData.description" placeholder="请输入奖品描述" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RewardEdit()">确 认</el-button>
            <el-button @click="dialogRewardEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑奖品弹框 End -->

        <!-- 删除奖品确认 -->
        <el-dialog title="操作确认" :visible.sync="dialogRewardDel" width="20%" class="confirmDel" :close-on-click-modal="false">
          <div class="confirmMsg">确定删除该奖品？</div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RewardDelete">确 定</el-button>
            <el-button @click="dialogRewardDel = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 删除奖品确认 End -->
      </div>
    </el-tab-pane>

    <!-- 兑换记录标签页 -->
    <el-tab-pane label="兑换记录管理" name="second">
      <div class="main">
        <div class="main_r">
          <!-- 搜索栏 -->
          <div class="search">
            <div>
              <el-input v-model="exchangeQuery.userid" placeholder="请输入用户ID"></el-input>
              <el-input v-model="exchangeQuery.rewardName" placeholder="请输入奖品名称"></el-input>
              <el-select v-model="exchangeQuery.status" placeholder="请选择状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="处理中" value="0"></el-option>
                <el-option label="已发货" value="1"></el-option>
              </el-select>
              <el-date-picker v-model="exchangeQuery.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" class="mr15"></el-date-picker>
              <el-date-picker v-model="exchangeQuery.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickExchangeQuery">查询</el-button>
              <el-button type="primary" @click="clickExchangeQueryReset" plain>重置</el-button>
            </div>
          </div>
          <!-- 搜索栏 End -->

          <!-- 兑换记录列表 -->
          <el-table :data="exchangeList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column prop="userid" label="用户ID" width="120"></el-table-column>
            <el-table-column prop="rewardImageUrl" label="奖品图片" width="100">
              <template slot-scope="scope">
                <el-image v-if="scope.row.rewardImageUrl" :src="getImageUrl(scope.row.rewardImageUrl)" :preview-src-list="[getImageUrl(scope.row.rewardImageUrl)]" style="width: 50px; height: 50px"></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="rewardName" label="奖品名称" width="150"></el-table-column>
            <el-table-column prop="points" label="消耗积分" width="100"></el-table-column>
            <el-table-column prop="recipientName" label="收货人" width="100"></el-table-column>
            <el-table-column prop="contactPhone" label="联系电话" width="120"></el-table-column>
            <el-table-column prop="shippingAddress" label="收货地址" min-width="200"></el-table-column>
            <el-table-column prop="trackingNumber" label="快递单号" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.trackingNumber || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.remark || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'">
                  {{ scope.row.status === 1 ? '已发货' : '处理中' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="兑换时间" width="160"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="160">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.status === 0" class="item" effect="dark" content="发货" placement="top" :enterable="false">
                  <el-button type="primary" size="mini" @click="clickExchangeShip(scope.row)">发货</el-button>
                </el-tooltip>
                <el-tooltip v-if="scope.row.status === 1" class="item" effect="dark" content="取消发货" placement="top" :enterable="false">
                  <el-button type="danger" size="mini" @click="clickExchangeCancelShip(scope.row)">取消发货</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleExchangeSizeChange"
              @current-change="handleExchangeCurrentChange"
              :current-page="exchangePageNo"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="exchangePageSize"
              layout="prev, pager, next, sizes, jumper"
              :total="exchangeTotal">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>

        <!-- 发货弹框 -->
        <el-dialog title="发货处理" :visible.sync="dialogExchangeShip" width="40%" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="exchangeShipForm" :model="exchangeShipData" label-width="100px">
              <el-form-item label="快递单号" :required="true">
                <el-input v-model="exchangeShipData.trackingNumber" placeholder="请输入快递单号" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" :rows="4" v-model="exchangeShipData.remark" placeholder="请输入备注" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="ExchangeShip()">确 认</el-button>
            <el-button @click="dialogExchangeShip = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 发货弹框 End -->

        <!-- 取消发货确认弹框 -->
        <el-dialog title="取消发货确认" :visible.sync="dialogExchangeCancelShip" width="40%" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="exchangeCancelShipForm" :model="exchangeCancelShipData" label-width="100px">
              <el-form-item label="备注" :required="true">
                <el-input type="textarea" :rows="4" v-model="exchangeCancelShipData.remark" placeholder="请输入备注（如：快递退回）" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="ExchangeCancelShip()">确 认</el-button>
            <el-button @click="dialogExchangeCancelShip = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 取消发货确认弹框 End -->
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      activeName: 'first',
      // 奖品管理相关数据
      rewardQuery: {
        rewardName: '',
        status: ''
      },
      rewardList: [],
      rewardTotal: 0,
      rewardPageNo: 1,
      rewardPageSize: 10,
      dialogRewardAdd: false,
      rewardAddData: {
        rewardName: '',
        rewardImageUrl: '',
        requiredPoints: 1,
        stock: 0,
        status: 1,
        sortOrder: 0,
        description: ''
      },
      dialogRewardEdit: false,
      rewardEditData: {
        id: '',
        rewardName: '',
        rewardImageUrl: '',
        requiredPoints: 1,
        stock: 0,
        status: 1,
        sortOrder: 0,
        description: ''
      },
      dialogRewardDel: false,
      rewardDeleteForm: {
        id: ''
      },
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/image',
      // 兑换记录相关数据
      exchangeQuery: {
        userid: '',
        rewardName: '',
        status: '',
        startDate: '',
        endDate: ''
      },
      exchangeList: [],
      exchangeTotal: 0,
      exchangePageNo: 1,
      exchangePageSize: 10,
      dialogExchangeShip: false,
      exchangeShipData: {
        id: '',
        trackingNumber: '',
        remark: ''
      },
      dialogExchangeCancelShip: false,
      exchangeCancelShipData: {
        id: '',
        remark: ''
      }
    }
  },
  mounted () {
    this.RewardList()
  },
  methods: {
    // ========== 奖品管理方法 ==========
    handleRewardSizeChange (val) {
      this.rewardPageSize = val
      this.RewardList()
    },
    handleRewardCurrentChange (val) {
      this.rewardPageNo = val
      this.RewardList()
    },
    clickRewardQuery () {
      this.rewardPageNo = 1
      this.RewardList()
    },
    clickRewardQueryReset () {
      this.rewardQuery.rewardName = ''
      this.rewardQuery.status = ''
      this.clickRewardQuery()
    },
    clickRewardAdd () {
      this.dialogRewardAdd = true
      this.rewardAddData.rewardName = ''
      this.rewardAddData.rewardImageUrl = ''
      this.rewardAddData.requiredPoints = 1
      this.rewardAddData.stock = 0
      this.rewardAddData.status = 1
      this.rewardAddData.sortOrder = 0
      this.rewardAddData.description = ''
    },
    clickRewardEdit (row) {
      this.dialogRewardEdit = true
      this.rewardEditData.id = row.id
      this.rewardEditData.rewardName = row.rewardName
      this.rewardEditData.rewardImageUrl = row.rewardImageUrl || ''
      this.rewardEditData.requiredPoints = row.requiredPoints
      this.rewardEditData.stock = row.stock
      this.rewardEditData.status = row.status
      this.rewardEditData.sortOrder = row.sortOrder
      this.rewardEditData.description = row.description || ''
    },
    clickRewardDelete (row) {
      this.dialogRewardDel = true
      this.rewardDeleteForm.id = row.id
    },
    RewardList: function () {
      var that = this
      var params = {
        tempUuid: localStorage.getItem('tempUuid'),
        page: that.rewardPageNo,
        pageSize: that.rewardPageSize,
        rewardName: that.rewardQuery.rewardName,
        status: that.rewardQuery.status
      }
      axios.get(Vue.prototype.global.Url_RewardList, { 
        params: params,
        headers: {
          'Accept-Language': 'zh'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            that.rewardList = response.data.data.list
            that.rewardTotal = response.data.data.total
          } else {
            Vue.prototype.$message.error(response.data.message || '查询失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('查询失败')
        })
    },
    RewardAdd: function () {
      var that = this
      if (!that.rewardAddData.rewardName) {
        Vue.prototype.$message.error('请输入奖品名称')
        return
      }
      if (!that.rewardAddData.requiredPoints || that.rewardAddData.requiredPoints <= 0) {
        Vue.prototype.$message.error('所需积分必须大于0')
        return
      }
      if (that.rewardAddData.stock < 0) {
        Vue.prototype.$message.error('库存数量不能小于0')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        rewardName: that.rewardAddData.rewardName,
        rewardImageUrl: that.rewardAddData.rewardImageUrl,
        requiredPoints: that.rewardAddData.requiredPoints,
        stock: that.rewardAddData.stock,
        status: that.rewardAddData.status,
        sortOrder: that.rewardAddData.sortOrder,
        description: that.rewardAddData.description
      }
      axios.post(Vue.prototype.global.Url_RewardAdd, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '新增成功')
            that.RewardList()
            that.dialogRewardAdd = false
          } else {
            Vue.prototype.$message.error(response.data.message || '新增失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('新增失败')
          that.dialogRewardAdd = false
        })
    },
    RewardEdit: function () {
      var that = this
      if (!that.rewardEditData.rewardName) {
        Vue.prototype.$message.error('请输入奖品名称')
        return
      }
      if (!that.rewardEditData.requiredPoints || that.rewardEditData.requiredPoints <= 0) {
        Vue.prototype.$message.error('所需积分必须大于0')
        return
      }
      if (that.rewardEditData.stock < 0) {
        Vue.prototype.$message.error('库存数量不能小于0')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        id: that.rewardEditData.id,
        rewardName: that.rewardEditData.rewardName,
        rewardImageUrl: that.rewardEditData.rewardImageUrl,
        requiredPoints: that.rewardEditData.requiredPoints,
        stock: that.rewardEditData.stock,
        status: that.rewardEditData.status,
        sortOrder: that.rewardEditData.sortOrder,
        description: that.rewardEditData.description
      }
      axios.post(Vue.prototype.global.Url_RewardEdit, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '编辑成功')
            that.RewardList()
            that.dialogRewardEdit = false
          } else {
            Vue.prototype.$message.error(response.data.message || '编辑失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('编辑失败')
          that.dialogRewardEdit = false
        })
    },
    RewardDelete: function () {
      var that = this
      axios.post(Vue.prototype.global.Url_RewardDelete + '?tempUuid=' + localStorage.getItem('tempUuid') + '&id=' + that.rewardDeleteForm.id, null, {
        headers: {
          'Accept-Language': 'zh'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '删除成功')
            that.RewardList()
          } else {
            Vue.prototype.$message.error(response.data.message || '删除失败')
          }
          that.dialogRewardDel = false
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('删除失败')
          that.dialogRewardDel = false
        })
    },
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        Vue.prototype.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        Vue.prototype.$message.error('上传图片大小不能超过 2MB!')
        return false
      }

      return true
    },
    handleRewardAddUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      data.sign = Vue.prototype.FunGetSign(data)
      data.type = 'ajax'
      
      formData.append('file', options.file)
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      
      // 显示 loading
      const loading = Vue.prototype.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          var resData = response.data.data || {}
          var imageUrl = ''
          if (typeof resData === 'string') {
            imageUrl = resData
          } else if (resData.absoluteUrl) {
            imageUrl = resData.absoluteUrl
          } else if (resData.relativeUrl) {
            imageUrl = Vue.prototype.global.Url_Base + resData.relativeUrl
          }
          that.rewardAddData.rewardImageUrl = imageUrl
          Vue.prototype.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          Vue.prototype.$message.error('上传失败：' + response.data.msg)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        Vue.prototype.$message.error('上传失败！')
        options.onError(error)
      }).finally(function () {
        // 关闭 loading
        loading.close()
      })
    },
    handleRewardEditUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      data.sign = Vue.prototype.FunGetSign(data)
      data.type = 'ajax'
      
      formData.append('file', options.file)
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      
      // 显示 loading
      const loading = Vue.prototype.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          var resData = response.data.data || {}
          var imageUrl = ''
          if (typeof resData === 'string') {
            imageUrl = resData
          } else if (resData.absoluteUrl) {
            imageUrl = resData.absoluteUrl
          } else if (resData.relativeUrl) {
            imageUrl = Vue.prototype.global.Url_Base + resData.relativeUrl
          }
          that.rewardEditData.rewardImageUrl = imageUrl
          Vue.prototype.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          Vue.prototype.$message.error('上传失败：' + response.data.msg)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        Vue.prototype.$message.error('上传失败！')
        options.onError(error)
      }).finally(function () {
        // 关闭 loading
        loading.close()
      })
    },
    // ========== 兑换记录管理方法 ==========
    handleExchangeSizeChange (val) {
      this.exchangePageSize = val
      this.ExchangeList()
    },
    handleExchangeCurrentChange (val) {
      this.exchangePageNo = val
      this.ExchangeList()
    },
    clickExchangeQuery () {
      this.exchangePageNo = 1
      this.ExchangeList()
    },
    clickExchangeQueryReset () {
      this.exchangeQuery.userid = ''
      this.exchangeQuery.rewardName = ''
      this.exchangeQuery.status = ''
      this.exchangeQuery.startDate = ''
      this.exchangeQuery.endDate = ''
      this.clickExchangeQuery()
    },
    clickExchangeShip (row) {
      this.dialogExchangeShip = true
      this.exchangeShipData.id = row.id
      this.exchangeShipData.trackingNumber = ''
      this.exchangeShipData.remark = ''
    },
    clickExchangeCancelShip (row) {
      this.dialogExchangeCancelShip = true
      this.exchangeCancelShipData.id = row.id
      this.exchangeCancelShipData.remark = ''
    },
    ExchangeList: function () {
      var that = this
      var params = {
        tempUuid: localStorage.getItem('tempUuid'),
        page: that.exchangePageNo,
        pageSize: that.exchangePageSize
      }
      if (that.exchangeQuery.userid) params.userid = that.exchangeQuery.userid
      if (that.exchangeQuery.rewardName) params.rewardName = that.exchangeQuery.rewardName
      if (that.exchangeQuery.status !== '') params.status = that.exchangeQuery.status
      if (that.exchangeQuery.startDate) params.startDate = that.exchangeQuery.startDate
      if (that.exchangeQuery.endDate) params.endDate = that.exchangeQuery.endDate
      
      axios.get(Vue.prototype.global.Url_ExchangeList, { 
        params: params,
        headers: {
          'Accept-Language': 'zh'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            that.exchangeList = response.data.data.list
            that.exchangeTotal = response.data.data.total
          } else {
            Vue.prototype.$message.error(response.data.message || '查询失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('查询失败')
        })
    },
    ExchangeShip: function () {
      var that = this
      if (!that.exchangeShipData.trackingNumber) {
        Vue.prototype.$message.error('请输入快递单号')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        id: that.exchangeShipData.id,
        trackingNumber: that.exchangeShipData.trackingNumber,
        remark: that.exchangeShipData.remark
      }
      axios.post(Vue.prototype.global.Url_ExchangeShip, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '发货成功')
            that.ExchangeList()
            that.dialogExchangeShip = false
          } else {
            Vue.prototype.$message.error(response.data.message || '发货失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('发货失败')
          that.dialogExchangeShip = false
        })
    },
    ExchangeCancelShip: function () {
      var that = this
      if (!that.exchangeCancelShipData.remark) {
        Vue.prototype.$message.error('请输入备注')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        id: that.exchangeCancelShipData.id,
        remark: that.exchangeCancelShipData.remark
      }
      axios.post(Vue.prototype.global.Url_ExchangeCancelShip, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '取消发货成功')
            that.ExchangeList()
            that.dialogExchangeCancelShip = false
          } else {
            Vue.prototype.$message.error(response.data.message || '取消发货失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('取消发货失败')
          that.dialogExchangeCancelShip = false
        })
    },
    // ========== 通用方法 ==========
    getImageUrl (url) {
      if (!url) return ''
      if (typeof url === 'object') {
        if (url.absoluteUrl) {
          return url.absoluteUrl
        }
        if (url.relativeUrl) {
          return Vue.prototype.global.Url_Base + url.relativeUrl
        }
        return ''
      }
      const urlStr = String(url)
      if (urlStr.indexOf('http://') === 0 || urlStr.indexOf('https://') === 0) {
        return urlStr
      }
      return Vue.prototype.global.Url_Base + urlStr
    }
  },
  watch: {
    activeName (newVal) {
      if (newVal === 'first') {
        this.RewardList()
      } else if (newVal === 'second') {
        this.ExchangeList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.confirmMsg {
  text-align: center;
  font-size: 16px;
  color: #333;
  padding: 20px 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
